export { default } from './part-service-content';
